(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentFileController', DocumentFileController);

    DocumentFileController.$inject = ['DocumentFile'];

    function DocumentFileController(DocumentFile) {

        var vm = this;

        vm.documentFiles = [];
        var loaded = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            // EDOCS-652: GET api/document-files (every file, for any signed-in user) no longer exists. This
            // scaffold page has no menu link; it stays only as the parent of the file detail/edit states.
            loaded = [];
            vm.documentFiles = [];
            vm.searchQuery = null;
            vm.currentSearch = null;
        }

        function search() {
        if (!vm.searchQuery) {
            vm.documentFiles = loaded;
            vm.currentSearch = null;
            return;
        }
        /* There is no search endpoint for this entity. The XSearch service this used to call was
           JHipster Elasticsearch scaffolding that this application never had - injecting it threw
           "Unknown provider", which killed the whole controller, so the page rendered NOTHING at
           all. The list is loaded in full above, so the box filters what is already here. */
        var needle = String(vm.searchQuery).toLowerCase();
        vm.documentFiles = loaded.filter(function(item) {
            return Object.keys(item).some(function(key) {
                var value = item[key];
                return value !== null && value !== undefined && typeof value !== 'object' &&
                    String(value).toLowerCase().indexOf(needle) !== -1;
            });
        });
        vm.currentSearch = vm.searchQuery;
        }

        function clear() {
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.documentFiles = loaded;
        }
    }
})();
